// 公共方法
// 时间格式化原文：https://www.jb51.net/article/144235.htm
export function formatDate (date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + ''
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
      }
    }
    return fmt
  }
  
  function padLeftZero (str) {
    return ('00' + str).substr(str.length)
  }

  // 放回顶部
  export function toTop(){
    let distance = document.documentElement.scrollTop || document.body.scrollTop; //获得当前高度
    let step = distance/50; //每步的距离
    (function jump(){
      if(distance > 0){
        distance-=step;
        window.scrollTo(0,distance);
        setTimeout(jump,10)
      }
    })();
  }

// 解析请求栏参数,主要用于网页授权后回调地址带hash#,获取hash#前面的参数
// http://localhost:8080/?code=12313123&a=444#/photograph  => {code:12313123,a:444}
  export const getParam = (key) => {
    let href = location.href.split('#')[0]  // http://localhost:8080/?code=12313123&a=444
    let queryString = href.split('?')[1] // code=12313123&a=444
    if (!queryString) {
        return false
    }
    let query = queryString.split('&')
    let obj = {}
    for (let i = 0; i < query.length; i++) {
        let arr = query[i].split('=')
        obj[arr[0]] = arr[1]
    }
    if (key) {
        return obj[key]
    }
    return obj
}